import { API_ROUTES, ApiService } from '@shared/api-utils';

let refreshPromise: Promise<boolean> | null = null;

async function refreshSession(baseUrl: string): Promise<boolean> {
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = performRefresh(baseUrl).finally(() => {
    refreshPromise = null;
  });

  return refreshPromise;
}

async function performRefresh(baseUrl: string): Promise<boolean> {
  try {
    const apiService = ApiService.getInstance(baseUrl);

    const response = await apiService.get(API_ROUTES.MY_ACCOUNT.PLAYER_AUTH.TOKEN_REFRESH, {
      credentials: 'include',
    });

    return !response.error;
  } catch {
    return false;
  }
}

export { refreshSession };
